<template>
    <div id="hotel">
        <Topbar v-if="this.$store.state.topbar_actions_visible" @action="fnAction"></Topbar>
        <v-container class="main left">
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm6 md3 class="logo" >
                    <img :src="( hotel.avatar )? hotel.avatar : '/img/hotel_building.svg'" />
                </v-flex>
                <v-flex xs12 sm6 md9 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "basic_info" ) }}</v-flex>
                            <v-flex xs12 md6>
                                
                                <div class="label">{{ $t( "params.name" ) }}:</div>
                                <div class="value">{{ hotel.name | checkParam }}</div>

                                <div class="label">{{ $t( "params.state" ) }}:</div>
                                <div class="value">{{ hotel.state | checkParam }}</div>

                                <div class="label">{{ $t( "params.cp" ) }}:</div>
                                <div class="value">{{ hotel.cp | checkParam }}</div>

                                <div class="label">{{ $t( "params.category" ) }}:</div>
                                <div class="value">{{ hotel.category_label | checkParam }}</div>

                                <div class="label">{{ $t( "params.bussines" ) }}:</div>
                                <div class="value">{{ hotel.bussines | checkParam }}</div>
                                
                                <div class="label">
                                    <Phone :phone="$t( 'params.phone' ) + ':'"></Phone>
                                </div>
                                <div class="value">{{ hotel.phone | checkParam }}</div>

                                <div class="label">{{ $t( "params.web" ) }}:</div>
                                <div class="value">{{ hotel.web | checkParam }}</div>

                                <div class="label">{{ $t( "params.halal" ) }}:</div>
                                <div class="value">{{ hotel.halal | checkParam }}</div>
                                
                                <div class="label">{{ $t( "params.picnic" ) }}:</div>
                                <div class="value">{{ hotel.picnic | checkParam }}</div>

                                <div class="label">{{ $t( "params.extra_meal" ) }}:</div>
                                <div class="value">{{ hotel.extra_meal | checkParam }}</div>

                                <div class="label">{{ $t( "params.parking" ) }}:</div>
                                <div class="value">{{ hotel.parking | checkParam }}</div>

                                <div class="label">{{ $t( "params.bressol" ) }}:</div>
                                <div class="value">{{ hotel.bressol | checkParam }}</div> 

                                <div class="label">{{ $t( "params.late_checkout" ) }}:</div>
                                <div class="value">{{ hotel.late_checkout | checkParam }}</div>

                                <div class="label">{{ $t( "params.buffet" ) }}:</div>
                                <div class="value">{{ hotel.buffet | checkParam }}</div>

                                <div class="label">{{ $t( "params.rooms" ) }}:</div>
                                <div class="value">{{ hotel.rooms | checkParam }}</div>

                                <div class="label">{{ $t( "params.pool" ) }}:</div>
                                <div class="value">{{ hotel.pool | checkParam }}</div>
                            </v-flex>
                            <v-flex xs12 md6>
                                <div class="label">{{ $t( "params.city" ) }}:</div>
                                <div class="value">{{ hotel.city | checkParam }}</div>

                                <div class="label">{{ $t( "params.address" ) }}:</div>
                                <div class="value">{{ hotel.address | checkParam }}</div>

                                <div class="label">{{ $t( "params.country" ) }}:</div>
                                <div class="value">
                                    <Country v-if="hotel.country_id" :country="country"></Country>
                                    <span v-else>-</span>
                                </div>

                                <div class="label">{{ $t( "params.nif" ) }}:</div>
                                <div class="value">{{ hotel.nif | checkParam }}</div>

                                 <div class="label">
                                    <Phone :phone="$t( 'params.phone2' ) + ':'"></Phone>
                                </div>
                                <div class="value">{{ hotel.phone2 | checkParam }}</div>

                                <div class="label">
                                    <Email :email="$t( 'params.email' ) + ':'"></Email>
                                </div>
                                <div class="value">{{ hotel.email | checkParam }}</div>

                                <div class="label">{{ $t( "params.pc_halal" ) }}:</div>
                                <div class="value">{{ hotel.pc_halal | checkParam }}</div>
                                
                                <div class="label">{{ $t( "params.pc_picnic" ) }}:</div>
                                <div class="value">{{ hotel.pc_picnic | checkParam }}</div>

                                <div class="label">{{ $t( "params.pc_extra_meal" ) }}:</div>
                                <div class="value">{{ hotel.pc_extra_meal | checkParam }}</div>

                                <div class="label">{{ $t( "params.pc_parking" ) }}:</div>
                                <div class="value">{{ hotel.pc_parking | checkParam }}</div>

                                <div class="label">{{ $t( "params.pc_bressol" ) }}:</div>
                                <div class="value">{{ hotel.pc_bressol | checkParam }}</div> 

                                <div class="label">{{ $t( "params.pc_late_checkout" ) }}:</div>
                                <div class="value">{{ hotel.pc_late_checkout | checkParam }}</div>

                                <div class="label">{{ $t( "params.dining_capacity" ) }}:</div>
                                <div class="value">{{ hotel.dining_capacity | checkParam }}</div>

                                <div class="label">{{ $t( "params.gym" ) }}:</div>
                                <div class="value">{{ hotel.gym | checkParam }}</div>

                                <div class="label">{{ $t( "params.observations" ) }}:</div>
                                <div class="value">{{ hotel.observations | checkParam }}</div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex xs12 sm12 md12 class="info" v-if="Object.values(currentEvent).length > 0">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "hotels.availability" ) }}<div @click="addAvailability = true" class="add">{{ 'hotels.add_availability' | i18n }}</div></v-flex>
                            <v-flex md12 class="hotel">
                                <v-data-table
                                    :headers="availability_headers"
                                    :items="Object.values(availability)"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    :loading="false"
                                >
                                <template v-slot:items="props">
                                    <tr style="height: 50px;">
                                        <td>{{ parseInt(props.item.visible) ? '★' : '' }}</td>
                                        <td>{{ props.item.start_date | showDate }}</td>
                                        <td>{{ props.item.end_date | showDate }}</td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.rooms_used > props.item.rooms }">{{props.item.rooms_used}}</span> / {{ props.item.rooms }}</td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_1pax_used > props.item.num_rooms_1pax }">{{props.item.num_rooms_1pax_used == null ? 0 : props.item.num_rooms_1pax_used}}</span>/<span class="total">{{ props.item.num_rooms_1pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_2pax_used > props.item.num_rooms_2pax }">{{props.item.num_rooms_2pax_used == null ? 0 : props.item.num_rooms_2pax_used}}</span>/<span class="total">{{ props.item.num_rooms_2pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_3pax_used > props.item.num_rooms_3pax }">{{props.item.num_rooms_3pax_used == null ? 0 : props.item.num_rooms_3pax_used}}</span>/<span class="total">{{ props.item.num_rooms_3pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_4pax_used > props.item.num_rooms_4pax }">{{props.item.num_rooms_4pax_used == null ? 0 : props.item.num_rooms_4pax_used}}</span>/<span class="total">{{ props.item.num_rooms_4pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_5pax_used > props.item.num_rooms_5pax }">{{props.item.num_rooms_5pax_used == null ? 0 : props.item.num_rooms_5pax_used}}</span>/<span class="total">{{ props.item.num_rooms_5pax }}</span></td>
                                        <td class="centertext">{{ props.item.pax }}</td>
                                        <td>{{ props.item.observations }}</td>
                                        <td style="text-align: center;">                                            
                                            <v-icon @click="editAvailability(props.item)">edit</v-icon>
                                            <v-icon  @click="deleteAvailability(props.item)">delete</v-icon>                 
                                        </td>
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>


                <v-flex xs12 sm12 md12 class="info" v-if="Object.values(currentEvent).length > 0">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "hotels.rooming" ) }}<div @click="addRooming = true; availability_rooming = {...availability};" class="add">{{ 'hotels.add_rooming' | i18n }}</div></v-flex>
                            <v-flex md12 class="hotel">
                                <v-data-table
                                    :headers="roomings_assigned_headers"
                                    :items="Object.values(roomings_assigned)"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    :loading="false"
                                >
                                <template v-slot:items="props">
                                    <tr style="height: 50px;" v-if="teams[props.item.entity_id]">
                                        <td>{{ teams[props.item.entity_id].name }}</td>
                                        <td>{{ teams[props.item.entity_id].category.max_age }}</td>
                                        <td>{{ roomingStatus(props.item.status) }}</td>
                                        <td>{{ Boolean(parseInt(props.item.alergy)) | checkParam }}</td>
                                        <td>{{ props.item.start_date | showDate }}</td>
                                        <td>{{ props.item.end_date | showDate }}</td>
                                        <td>{{ $t(hotel_services[props.item.first_hotel_service_id].name) }}</td>
                                        <td>{{ $t(hotel_services[props.item.last_hotel_service_id].name) }}</td>
                                        <td>{{ props.item.rooms}}</td>
                                        <td>{{ props.item.num_rooms_1pax }}</td>
                                        <td>{{ props.item.num_rooms_2pax }}</td>
                                        <td>{{ props.item.num_rooms_3pax }}</td>
                                        <td>{{ props.item.num_rooms_4pax }}</td>
                                        <td>{{ props.item.num_rooms_5pax }}</td>
                                        <td>{{ props.item.pax }}</td>
                                        <td>{{ props.item.observations }}</td>
                                        <td style="text-align: center;">                                             
                                            <img class="icon" src="/img/change.svg" @click="loadChangeHotelRooming( props.item.id )">
                                        </td>
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>


            </v-layout>
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <LastUpdate :data="hotel.user_modify"></LastUpdate> 
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="section-container" id="notes">
                <NoteList :notes="hotel.notes" :page="'hotel'" :id="id" @create_note="createNote"></NoteList>
            </v-layout>
        </v-container>

        <ContactList
        v-if="hotel"
      :contacts="hotel.contacts"
      :entity="'hotel'"
      class="contact right"
    ></ContactList>

        <!-- <ContactRelationsList :contacts_rel="hotel.current_roles" class="contact right"></ContactRelationsList> -->
        
        <!-- AVAILABILITY POPUP -->
        <v-dialog persistent v-model="addAvailability" width="800" v-if="Object.values(currentEvent).length > 0">
          <v-card class="availability popup">
            <v-card-title
              class="headline grey lighten-2"
              primary-title
              style="padding: 8px 10px; font-size: 20px !important;"
              >{{ 'hotels.add_availability' | i18n }}
            </v-card-title>

            <v-card-text style="padding: 8px 10px;margin-top:10px;">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 md12>
                                <div class="label error" v-if="error.start_date || error.end_date">{{ $t(error.availability_msg) }}</div>
                            </v-flex>
                            <v-flex xs6 md6>
                                <div class="label">{{ $t( "hotels.entry_day" ) }}:</div>
                                <div class="item">
                                      <v-menu v-model="dialog_start_date" autocomplete="new-text" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field readonly hide-details v-bind:class="error.start_date ? 'input-error' : ''" append-icon="event" v-model="newAvailability.parsedEntryDate" @click:append="dialog_start_date = true" @click="dialog_start_date = true" :placeholder="'DD/MM/YYYY' ">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="newAvailability.start_date" color="blue-grey lighten-2" @input="dialog_start_date = false, formatEntryDate()" :first-day-of-week="1" locale="ca"></v-date-picker>
                                    </v-menu>
                                </div>
                            </v-flex>
                            <v-flex xs6 md6>
                                <div class="label">{{ $t( "hotels.departure_day" ) }}:</div>
                                <div class="item">
                                      <v-menu v-model="dialog_end_date" autocomplete="new-text" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field readonly hide-details v-bind:class="error.end_date ? 'input-error' : ''" append-icon="event" v-model="newAvailability.parsedDepartureDate" @click:append="dialog_end_date = true" @click="dialog_end_date = true" :placeholder="'DD/MM/YYYY' ">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="newAvailability.end_date" color="blue-grey lighten-2" @input="dialog_end_date = false, formatDepartureDate()" :first-day-of-week="1" locale="ca"></v-date-picker>
                                    </v-menu>
                                </div>
                            </v-flex>
                            <v-flex xs6 md6>
                                <div class="label inlineblock">{{ $t( "params.pax" ) }}:</div> <span class="counter">{{pax}}</span>
                            </v-flex>
                            <v-flex xs6 md6>
                                <div class="label inlineblock">{{ $t( "hotels.rooms" ) }}:</div> <span class="counter">{{rooms}}</span>
                            </v-flex>
                            <v-flex xs12 md12 class="rooms">
                                <div class="room inlineblock">
                                    <input type="number" @focus="newAvailability.num_rooms_1pax == 0 ? newAvailability.num_rooms_1pax = '' : newAvailability.num_rooms_1pax" @blur="newAvailability.num_rooms_1pax == '' ? newAvailability.num_rooms_1pax = 0 : newAvailability.num_rooms_1pax" @input="calculatePaxRooms(1)" v-model="newAvailability.num_rooms_1pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.individual" ) }}</span>
                                </div>
                                <div class="room inlineblock">
                                    <input type="number" @focus="newAvailability.num_rooms_2pax == 0 ? newAvailability.num_rooms_2pax = '' : newAvailability.num_rooms_2pax" @blur="newAvailability.num_rooms_2pax == '' ? newAvailability.num_rooms_2pax = 0 : newAvailability.num_rooms_2pax" @input="calculatePaxRooms(2)" v-model="newAvailability.num_rooms_2pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.double" ) }}</span>
                                </div>
                                <div class="room inlineblock">
                                    <input type="number" @focus="newAvailability.num_rooms_3pax == 0 ? newAvailability.num_rooms_3pax = '' : newAvailability.num_rooms_3pax" @blur="newAvailability.num_rooms_3pax == '' ? newAvailability.num_rooms_3pax = 0 : newAvailability.num_rooms_3pax" @input="calculatePaxRooms(3)" v-model="newAvailability.num_rooms_3pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.triple" ) }}</span>
                                </div>
                                <div class="room inlineblock">
                                    <input type="number" @focus="newAvailability.num_rooms_4pax == 0 ? newAvailability.num_rooms_4pax = '' : newAvailability.num_rooms_4pax" @blur="newAvailability.num_rooms_4pax == '' ? newAvailability.num_rooms_4pax = 0 : newAvailability.num_rooms_4pax" @input="calculatePaxRooms(4)" v-model="newAvailability.num_rooms_4pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.quadruple" ) }}</span>
                                </div>
                                <div class="room inlineblock">
                                    <input type="number" @focus="newAvailability.num_rooms_5pax == 0 ? newAvailability.num_rooms_5pax = '' : newAvailability.num_rooms_5pax" @blur="newAvailability.num_rooms_5pax == '' ? newAvailability.num_rooms_5pax = 0 : newAvailability.num_rooms_5pax" @input="calculatePaxRooms(5)" v-model="newAvailability.num_rooms_5pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.quintuple" ) }}</span>
                                </div>
                            </v-flex>
                            <v-flex xs12 md12>
                              <div class="label">{{ $t( "params.observations" ) }}:</div>
                              <v-textarea auto-grow v-model="newAvailability.observations"></v-textarea>
                            </v-flex>
                            <v-flex xs12 md12>
                                <div class="label error" v-if="error.visible">{{ $t('hotels.errors.availability_visible_msg') }}</div>
                                <div class="label">{{ $t( "hotels.availability_visible" ) }}:</div>
                                <v-checkbox
                                color="#8bc34a"
                                class="filter-checkbox"
                                hide-details
                                v-model="newAvailability.visible"
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="primary" flat @click="closeAvailability()">{{
                `close` | i18n
              }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="saveAvailability()">{{
                `add` | i18n
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- ROOMING POPUP -->
        <v-dialog persistent v-model="addRooming" width="80%" v-if="Object.values(currentEvent).length > 0">
          <v-card class="rooming popup">
            <v-card-title
              class="headline grey lighten-2"
              primary-title
              style="padding: 8px 10px; font-size: 20px !important;"
              >{{ 'hotels.add_rooming' | i18n }}
            </v-card-title>

            <v-card-text style="padding: 8px 10px;margin-top:10px;">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs6 md6>
                                <div class="label inlineblock">{{ $t( "params.category" ) }}:</div>
                                <div class="item inlineblock">
                                    <v-select
                                      :items="Object.values(currentEvent.categories)"
                                      v-model="categorySelected"
                                      item-text="max_age"
                                      item-value="id"
                                      @change="team_rooming = []; availability_rooming = {...availability}; selectedTeamId = false; loadRoomingCategory()"
                                      multiple
                                    ></v-select>
                                </div>
                            </v-flex>

                            <v-flex xs6 md6>
                                <div class="label">{{ $t( "team" ) }}:</div> 
                                <div class="item inlineblock">
                                    <v-autocomplete
                                        hide-details
                                        v-model="selectedTeamId"
                                        :items="teamsByCategory"
                                        :disabled="categorySelected == null"
                                        :no-data-text="$t('hotels.no_teams_found_category')"
                                        :no-results-text="$t('hotels.no_teams_found_category')"
                                        item-text="name"
                                        item-value="id"
                                        @change="loadRoomingTeam()"
                                    >
                                    </v-autocomplete>
                                </div>
                            </v-flex>

                            <v-flex xs12 md12>
                                <div class="label" style="margin-top: -10px; margin-bottom: 10px;">{{ $t( "hotels.rooming_team_info" ) }}:</div> 
                                <v-data-table
                                    :headers="rooming_headers"
                                    :items="team_rooming"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :rows-per-page-text="''"
                                    sort-by="team_name"
                                    hide-actions
                                    :loading="false"
                                    item-key="id"
                                    v-model="selectedRooming"
                                    show-select
                                >
                                    <template v-slot:items="props">
                                    <tr style="height: 50px;" v-if="getTeam(props.item.team_id)">
                                        <td>                                            
                                            <v-checkbox
                                              hide-details
                                              :value="props.item.selected"
                                              @click="$event.preventDefault();$event.stopPropagation();calculateRoomingInAvaiability(props)"
                                            ></v-checkbox>
                                        </td>
                                        <td>{{ getTeam(props.item.team_id).name}}</td>
                                        <td>{{ getTeam(props.item.team_id).category.max_age}}</td>
                                        <td>{{ roomingStatus(props.item.status) }}
                                        <td>{{ props.item.alergy | checkParam }}</td>
                                        <td>{{ props.item.start_date | showDate }}</td>
                                        <td>{{ props.item.end_date | showDate }}</td>
                                        <td>{{ $t(hotel_services[props.item.first_hotel_service_id].name) }}</td>
                                        <td>{{ $t(hotel_services[props.item.last_hotel_service_id].name) }}</td>
                                        <td>{{ props.item.num_rooms_1pax }}</td>
                                        <td>{{ props.item.num_rooms_2pax }}</td>
                                        <td>{{ props.item.num_rooms_3pax }}</td>
                                        <td>{{ props.item.num_rooms_4pax }}</td>
                                        <td>{{ props.item.num_rooms_5pax }}</td>
                                        <td>{{ props.item.pax }}</td>
                                        <!-- <td>{{ props.item.observations }}</td>
                                        <td style="text-align: center;">                                             
                                            <v-icon @click="editRooming(props.item)">edit</v-icon>
                                            <v-icon  @click="deleteRooming(props.item)">delete</v-icon>                  
                                        </td> -->
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>

                            <v-flex xs12 md12>
                                <div class="label" style="margin: 10px 0;">{{ $t( "hotels.availability_info" ) }}:</div>
                                <v-data-table
                                    :headers="availability_rooming_headers"
                                    :items="Object.values(availability_rooming)"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    :loading="false"
                                >
                                <template v-slot:items="props">
                                    <tr style="height: 50px;">
                                        <td>{{ props.item.start_date | showDate }}</td>
                                        <td>{{ props.item.end_date | showDate }}</td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.rooms_used > props.item.rooms }">{{props.item.rooms_used}}</span> / {{ props.item.rooms }}</td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_1pax_used > props.item.num_rooms_1pax }">{{props.item.num_rooms_1pax_used == null ? 0 : props.item.num_rooms_1pax_used}}</span>/<span class="total">{{ props.item.num_rooms_1pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_2pax_used > props.item.num_rooms_2pax }">{{props.item.num_rooms_2pax_used == null ? 0 : props.item.num_rooms_2pax_used}}</span>/<span class="total">{{ props.item.num_rooms_2pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_3pax_used > props.item.num_rooms_3pax }">{{props.item.num_rooms_3pax_used == null ? 0 : props.item.num_rooms_3pax_used}}</span>/<span class="total">{{ props.item.num_rooms_3pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_4pax_used > props.item.num_rooms_4pax }">{{props.item.num_rooms_4pax_used == null ? 0 : props.item.num_rooms_4pax_used}}</span>/<span class="total">{{ props.item.num_rooms_4pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_5pax_used > props.item.num_rooms_5pax }">{{props.item.num_rooms_5pax_used == null ? 0 : props.item.num_rooms_5pax_used}}</span>/<span class="total">{{ props.item.num_rooms_5pax }}</span></td>
                                        <td class="centertext">{{ props.item.pax }}</td>
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                            
                        </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="primary" flat @click="closeRooming()">{{
                `close` | i18n
              }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="saveRooming()">{{
                `add` | i18n
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <!-- CHANGE HOTEL ROOMING POPUP -->
        <v-dialog persistent v-model="changeHotelRooming" width="80%" v-if="Object.values(currentEvent).length > 0 && currentRooming">
          <v-card class="rooming popup changehotel">
            <v-card-title
              class="headline grey lighten-2"
              primary-title
              style="padding: 8px 10px; font-size: 20px !important;"
              >{{ 'hotels.add_rooming' | i18n }}
            </v-card-title>

            <v-card-text style="padding: 8px 10px;margin-top:10px;">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs6 md6>
                                <div class="label inlineblock">{{ $t( "params.category" ) }}:</div>
                                <div class="item inlineblock">
                                    <v-select
                                      v-if="currentRooming"
                                      :items="Object.values(currentEvent.categories)"
                                      v-model="currentRooming.team.category.id"
                                      item-text="name"
                                      item-value="id"
                                      :disabled="true"
                                      @change="team_rooming = []; availability_rooming = {...availability}; selectedTeamId = false"
                                    ></v-select>
                                </div>
                            </v-flex>

                            <v-flex xs6 md6>
                                <div class="label">{{ $t( "team" ) }}:</div> 
                                <div class="item inlineblock">
                                    <v-autocomplete
                                        v-if="currentRooming"
                                        hide-details
                                        v-model="currentRooming.team.id"
                                        :items="Object.values(teams)"
                                        :disabled="true"
                                        :no-data-text="$t('hotels.no_teams_found_category')"
                                        :no-results-text="$t('hotels.no_teams_found_category')"
                                        item-text="name"
                                        item-value="id"
                                        @change="loadRoomingTeam()"
                                    >
                                    </v-autocomplete>
                                </div>
                            </v-flex>

                            <v-flex xs12 md12>
                                <div class="label" style="margin-top: -10px; margin-bottom: 10px;">{{ $t( "hotels.rooming_team_selected" ) }}:</div> 
                                <v-data-table
                                    :headers="rooming_changehotel_headers"
                                    :items="[currentRooming]"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    sort-by="team_name"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    :loading="false"  
                                    item-key="id"
                                >
                                    <template v-slot:items="props">
                                    <tr style="height: 50px;" v-if="getTeam(props.item.team_id)">
                                        <td>{{ props.item.start_date | showDate }}</td>
                                        <td>{{ props.item.end_date | showDate }}</td>
                                        <td>{{ getTeam(props.item.team_id).name}}</td>
                                        <td>{{ $t(hotel_services[props.item.first_hotel_service_id].name) }}</td>
                                        <td>{{ $t(hotel_services[props.item.last_hotel_service_id].name) }}</td>
                                        <td>{{ props.item.num_rooms_1pax }}</td>
                                        <td>{{ props.item.num_rooms_2pax }}</td>
                                        <td>{{ props.item.num_rooms_3pax }}</td>
                                        <td>{{ props.item.num_rooms_4pax }}</td>
                                        <td>{{ props.item.num_rooms_5pax }}</td>
                                        <td>{{ props.item.pax }}</td>
                                        <!-- <td>{{ props.item.observations }}</td>
                                        <td style="text-align: center;">                                             
                                            <v-icon @click="editRooming(props.item)">edit</v-icon>
                                            <v-icon  @click="deleteRooming(props.item)">delete</v-icon>                  
                                        </td> -->
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>

                            <v-flex xs6 md6 style="margin-top: 15px">
                                <div class="label inlineblock">{{ $t( "hotels.select_hotel" ) }}:</div>
                                <div class="item inlineblock">
                                    <v-select
                                      v-if="currentRooming"
                                      :items="Object.values(hotels_by_event)"
                                      v-model="changehotel_rooming_hotel_id"
                                      item-text="name"
                                      item-value="id"
                                    ></v-select>
                                </div>
                            </v-flex>

                            <v-flex xs12 md12>
                                <div class="label" style="margin: 0 0;">{{ $t( "hotels.availability_info" ) }}:</div>
                                <v-data-table
                                    :headers="availability_rooming_headers"
                                    :items="Object.values(changehotel_availability_rooming)"
                                    class="elevation-1"
                                    :no-data-text="$t('hotels.no_availability_found')"
                                    :no-results-text="$t('hotels.no_availability_found')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    :loading="false"
                                >
                                <template v-slot:items="props">
                                    <tr style="height: 50px;">
                                        <td>{{ props.item.start_date | showDate }}</td>
                                        <td>{{ props.item.end_date | showDate }}</td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.rooms_used > props.item.rooms }">{{props.item.rooms_used}}</span> / {{ props.item.rooms }}</td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_1pax_used > props.item.num_rooms_1pax }">{{props.item.num_rooms_1pax_used == null ? 0 : props.item.num_rooms_1pax_used}}</span>/<span class="total">{{ props.item.num_rooms_1pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_2pax_used > props.item.num_rooms_2pax }">{{props.item.num_rooms_2pax_used == null ? 0 : props.item.num_rooms_2pax_used}}</span>/<span class="total">{{ props.item.num_rooms_2pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_3pax_used > props.item.num_rooms_3pax }">{{props.item.num_rooms_3pax_used == null ? 0 : props.item.num_rooms_3pax_used}}</span>/<span class="total">{{ props.item.num_rooms_3pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_4pax_used > props.item.num_rooms_4pax }">{{props.item.num_rooms_4pax_used == null ? 0 : props.item.num_rooms_4pax_used}}</span>/<span class="total">{{ props.item.num_rooms_4pax }}</span></td>
                                        <td class="centertext"><span class="used" :class="{overbooking: props.item.num_rooms_5pax_used > props.item.num_rooms_5pax }">{{props.item.num_rooms_5pax_used == null ? 0 : props.item.num_rooms_5pax_used}}</span>/<span class="total">{{ props.item.num_rooms_5pax }}</span></td>
                                        <td class="centertext">{{ props.item.pax }}</td>
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                            
                        </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="primary" flat @click="closeChangeHotelRooming()">{{
                `close` | i18n
              }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="saveChangeHotelRooming()">{{
                `add` | i18n
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    </div>
</template>

<script>

import { Api } from "@/core/api.js";
import i18n from "@/i18n";
import NoteList from '@/components/ui/NoteList'
import TeamCard from '@/components/ui/cards/mini/Team'
import Topbar from '@/components/ui/Topbar'

import ContactList from '@/components/ui/ContactList'

import Phone from '@/components/ui/labels/Phone'
import Email from '@/components/ui/labels/Email'
import Country from '@/components/ui/labels/Country'
import LastUpdate from '@/components/ui/LastUpdate'

const api = new Api();

export default {
  name: 'CardHotel',
  components: { NoteList, TeamCard, Topbar, Phone, Email, Country, ContactList, LastUpdate },
  props: { },
  data () {
    return {
      id: this.$route.params.id,
      current_roles: [],
      pagination: {
        sortBy: "start_date",
        descending: false,
        rowsPerPage: -1,
        page: 1,
        totalItems: 0,
        totalFilteredItems: 0
      },

      // AVAILABILITY
      newAvailability: {
        num_rooms_1pax: 0,
        num_rooms_2pax: 0,
        num_rooms_3pax: 0,
        num_rooms_4pax: 0,
        num_rooms_5pax: 0,
        visible: 0
      },
      addAvailability: false,
      availability_headers: [
        { text: 'params.visible', value: 'visible', sortable: true },
        { text: 'hotels.entry_day', value: 'start_date', sortable: true },
        { text: 'hotels.departure_day', value: 'end_date', sortable: true },
        { text: 'hotels.rooms_short', value: 'rooms', sortable: true },
        { text: 'I', value: 'num_rooms_1pax', sortable: true },
        { text: 'II', value: 'num_rooms_2pax', sortable: true },
        { text: 'III', value: 'num_rooms_3pax', sortable: true },
        { text: 'IV', value: 'num_rooms_4pax', sortable: true },
        { text: 'V', value: 'num_rooms_5pax', sortable: true },
        { text: 'params.pax', value: 'pax', sortable: true },
        { text: 'hotels.observations_short', value: 'observations', sortable: true },
        { text: 'params.actions', sortable: false },
      ],

      // AVAILABILITY POPUP VARIABLES
      error: {
        start_date: false,
        end_date: false,
        visible: false
      },
      isEditAvailability: false,
      dialog_start_date: false,
      dialog_end_date: false,
      pax: 0,
      rooms: 0,

      // ROOMING
      selectedTeamId: false,
      addRooming: false,
      changeHotelRooming: false,
      rooming_headers: [
            { text: 'assign', value: 'id', sortable: false },
            { text: 'params.team', value: 'team_name' },
            { text: 'params.category', value: 'category', sortable: false },
            { text: 'params.status', value: 'status_name' },
            { text: 'params.alergy', value: 'alergy' },
            { text: 'hotels.entry_day', value: 'start_date', sortable: true },
            { text: 'hotels.departure_day', value: 'end_date', sortable: true },
            { text: 'hotels.first_hotel_service', value: 'first_hotel_service_id', sortable: true },
            { text: 'hotels.last_hotel_service', value: 'last_hotel_service_id', sortable: true },
            { text: 'I', value: 'num_rooms_1pax', sortable: true },
            { text: 'II', value: 'num_rooms_2pax', sortable: true },
            { text: 'III', value: 'num_rooms_3pax', sortable: true },
            { text: 'IV', value: 'num_rooms_4pax', sortable: true },
            { text: 'V', value: 'num_rooms_5pax', sortable: true },
            { text: 'params.pax', value: 'pax', sortable: true },
            // { text: 'params.observations', value: 'observations', sortable: true },
            // { text: 'params.actions', sortable: false },
       ],
       availability_rooming_headers: [
        { text: 'hotels.entry_day', value: 'start_date', sortable: true },
        { text: 'hotels.departure_day', value: 'end_date', sortable: true },
        { text: 'hotels.rooms_short', value: 'rooms', sortable: true },
        { text: 'I', value: 'num_rooms_1pax', sortable: true },
        { text: 'II', value: 'num_rooms_2pax', sortable: true },
        { text: 'III', value: 'num_rooms_3pax', sortable: true },
        { text: 'IV', value: 'num_rooms_4pax', sortable: true },
        { text: 'V', value: 'num_rooms_5pax', sortable: true },
        { text: 'params.pax', value: 'pax', sortable: true },
       ],

      // ROOMING POPUP VARIABLES
      // isEditRooming: false,
      categorySelected: null,
      selectedRooming: [],
      availability_rooming: [],
      team_rooming: [],

      // ASSIGNED ROOMINGS
      roomings_assigned_headers: [
        { text: 'titles.team', value: 'team_id', sortable: false },
        { text: 'params.category', value: 'category', sortable: false },
        { text: 'params.status', value: 'status', sortable: true },
        { text: 'params.alergy', value: 'alergy', sortable: true },
        { text: 'hotels.entry_day', value: 'start_date', sortable: true },
        { text: 'hotels.departure_day', value: 'end_date', sortable: true },
        { text: 'hotels.first_hotel_service', value: 'first_hotel_service_id', sortable: true },
        { text: 'hotels.last_hotel_service', value: 'last_hotel_service_id', sortable: true },
        { text: 'hotels.rooms_short', value: 'rooms', sortable: true },
        { text: 'I', value: 'num_rooms_1pax', sortable: true },
        { text: 'II', value: 'num_rooms_2pax', sortable: true },
        { text: 'III', value: 'num_rooms_3pax', sortable: true },
        { text: 'IV', value: 'num_rooms_4pax', sortable: true },
        { text: 'V', value: 'num_rooms_5pax', sortable: true },
        { text: 'params.pax', value: 'pax', sortable: true },
        { text: 'params.observations', value: 'observations', sortable: true },
        { text: 'params.actions', sortable: false },
      ],
      currentRooming: false,
      changehotel_rooming_hotel_id: false,
      changehotel_rooming_error: false,
      changehotel_availability_rooming: {},
      rooming_changehotel_headers: [
            { text: 'hotels.entry_day', value: 'start_date', sortable: true },
            { text: 'hotels.departure_day', value: 'end_date', sortable: true },
            { text: 'hotels.first_hotel_service', value: 'first_hotel_service_id', sortable: true },
            { text: 'hotels.last_hotel_service', value: 'last_hotel_service_id', sortable: true },
            { text: 'I', value: 'num_rooms_1pax', sortable: true },
            { text: 'II', value: 'num_rooms_2pax', sortable: true },
            { text: 'III', value: 'num_rooms_3pax', sortable: true },
            { text: 'IV', value: 'num_rooms_4pax', sortable: true },
            { text: 'V', value: 'num_rooms_5pax', sortable: true },
            { text: 'params.pax', value: 'pax', sortable: true },
            // { text: 'params.observations', value: 'observations', sortable: true },
            // { text: 'params.actions', sortable: false },
       ],
    }
  },
  computed: {
      hotel() {
            var ohotel = {...this.$store.getters[ 'hotels/get_by_id' ]( this.$route.params.id )};
            
            if( !ohotel ) ohotel = {};

            if( ohotel.category ){
                ohotel.category_label = i18n.t(this.$store.getters['hotels/getCategories'](ohotel.category).name )
            }

            ohotel.notes = ohotel.notes ? Object.values( ohotel.notes ) : [];
            ohotel.notes.sort( function( n1, n2 ){
              if( moment( n1.last_update ).valueOf() < moment( n2.last_update ).valueOf() ) return 1
              return -1
            })
            
            if( typeof ohotel.current_roles === 'undefined' ) ohotel.current_roles = []
            else{
                ohotel.current_roles.forEach( role => {
                    role.visible = true
                })
            }

            this.current_roles = ohotel.current_roles

            ohotel.contacts = ObjectToArray(ohotel.contacts);

            return ohotel
      },

      country() {
            if (this.hotel.country_id) {
                return { ...this.$store.getters.getCountryByID(this.hotel.country_id) };
            }
                return {};
      },

      availability() {
        return this.$store.getters[ 'hotels/getAvailability' ];
      },

      currentEvent() {
        return this.$store.getters[ 'events/getCurrentEvent' ]();
      },

      teams() {
        return this.$store.getters[ 'teams/getListKeyId' ]();
      },

      teamsByCategory() {
        return this.$store.getters[ 'teams/getListByCategory' ](this.categorySelected);
      },

      hotel_services() {
        return this.$store.getters.getHotelServices();
      },

      roomings_assigned() {
        return this.$store.getters[ 'hotels/getRoomingsAssigned' ];
      },

      hotels_by_event(){
          return Object.assign( { 'null': { id: null, name: i18n.t( 'hotels.no_assign' ) } }, this.$store.getters[ 'hotels/getList' ]() )
      }
  },
  created(){
        this.loadData()
  },
  methods: {
        loadData(){
            this.$overlay.loading()

            this.$store.commit( 'setTopbarActionsVisible', true );
            this.$store.commit( 'setMenuVisible', true );
                        
            var id = this.$route.params.id;
            var event_id = this.$store.getters[ "events/getCurrentEvent" ]().id;
            var self = this
            this.$store.dispatch( 'hotels/load_by_id', { id: id } ).then( function(){
                self.$store.dispatch( 'teams/loadList', { page_options: { num_page: 0, num_items: -1 },event: event_id,filters:{}}).then( function() {
                    if ( event_id != undefined ) {
                        self.$store.dispatch( 'hotels/loadAvailability', { hotel_id: id, event_id: event_id } ).then( function(){
                            self.$store.dispatch( 'hotels/loadRoomingsAssigned', { hotel_id: id, event_id: event_id }).then( function() {
                                self.$store.dispatch( 'hotels/loadList', { event: event_id, page_options: { num_page: 0, num_items: -1 } } ).then( function(){
                                    self.$overlay.hide();
                                });
                            });
                        });
                    }
                    else{
                        self.$overlay.hide();
                    }
                });
            });
        },

        createNote(){
            this.$card.note( { current_page: 'hotel', current_id: this.$route.params.id } );
        },

        createContactRelationship(){
            this.$card.contactrel( { current_page: 'hotel', current_id: this.$route.params.id } );
        },

        getCountry( id ){
            if( id ){
                return {...this.$store.getters.getCountryByID( id ) };
            }
            return false;
        },

        fnAction( emit ){
            if( typeof emit.action === 'undefined' || emit.action == null ) return
            switch( emit.action ){
                case 'remove':              this.fnRemove( emit.params )
                                            break
                case 'create_note':         this.createNote( emit.params )
                                            break
                case 'create_relationship': this.createContactRelationship( emit.params )
                                            break
                case 'rel_hotel_event':     this.fnRelHotelEvent( emit.params )
                                            break
                case 'destroy':             this.fnDestroy( emit.params )
                                            break
                case 'export_rooming':      this.exportRooming( emit.params )
                                            break
            }
        },

        fnRemove() {
        var self = this;
        this.$popup.confirm(
            {
              message: i18n.t("hotels.remove_message"),
              btnSuccess: i18n.t("accept"),
              btnError: i18n.t("cancel")
            },
            function() {
                var event = self.$store.getters.isEventSelected
                  ? self.$store.getters["events/getCurrentEvent"]().id
                  : false;
              self.$store.dispatch("hotels/remove", { hotel_id: self.id, event_id: event }).then(function() {
                  event = self.$store.getters.isEventSelected
                  ? self.$store.getters["events/getCurrentEvent"]()
                  : false;
                var page = event ? "event_" : "";
                page = page + "hotels";

                self.$router.push({
                  name: page,
                  params: {
                    event: event
                      ? self.$root
                          .formatEventUrl(event.name, event.edition)
                          .replace("/event/", "")
                      : null
                  }
                });
              });
            }
          );
        },

        fnRelHotelEvent() {
            if (!this.$store.getters.isEventSelected) {
                var self = this;
                this.$card.relHotelEvent({
                hotel_id: this.$route.params.id,
                event_id: this.$store.getters["events/getCurrentEvent"]().id,
                callBack: function(plug, params, store) {
                    self.$store
                    .dispatch("hotels/addRelHotelEvent", {
                        hotel_id: plug.params.hotel.value,
                        event_id: plug.params.event.value
                    })
                    .then(function() {
                        self.$popup.alert({
                        message: i18n.t("hotels.created_rel_hotel_event"),
                        btnSuccess: i18n.t("accept")
                        });
                        self.$card.close();
                    })
                    .catch(function(e) {
                        self.$popup.alert({
                        message: i18n.t("hotels." + e),
                        btnSuccess: i18n.t("accept")
                        });
                    });
                }
                });
            } else {
                this.$popup.alert({
                message: i18n.t("hotels.exist_rel_facility_event"),
                btnSuccess: i18n.t("accept")
                });
            }
        },

        fnDestroy(){
            this.$destroy()
        },

        // AVAILABILITY POPUP METHODS
        formatEntryDate() {
          this.newAvailability.parsedEntryDate = moment(this.newAvailability.start_date).format('DD/MM/YYYY');
          this.newAvailability.end_date = moment(this.newAvailability.start_date).add(1, 'days').format("YYYY-MM-DD");
          this.formatDepartureDate();
        },

        formatDepartureDate() {
          this.newAvailability.parsedDepartureDate = moment(this.newAvailability.end_date).format('DD/MM/YYYY');
        },

        editAvailability(item){
            this.addAvailability = true;
            this.newAvailability = {...item};
            this.newAvailability.visible = parseInt(this.newAvailability.visible)
            this.pax = item.pax;
            this.rooms = item.rooms;
            this.formatEntryDate();
            this.formatDepartureDate();
            this.isEditAvailability = true;
        },

        calculatePaxRooms(room) {
            var item = this.newAvailability;
            var numRoomChanged = item['num_rooms_'+room+'pax'];

            if ( parseInt(numRoomChanged) == NaN || parseInt(numRoomChanged) < 0 ) {
                this.newAvailability['num_rooms_'+room+'pax'] = 0;
            }

            if ( numRoomChanged != "" ) {
                this.pax = (parseInt(item.num_rooms_1pax) * 1) + (parseInt(item.num_rooms_2pax) * 2) + (parseInt(item.num_rooms_3pax) * 3) + (parseInt(item.num_rooms_4pax) * 4) +(parseInt(item.num_rooms_5pax) * 5);
                this.rooms = parseInt((parseInt(item.num_rooms_1pax)) + (parseInt(item.num_rooms_2pax)) + (parseInt(item.num_rooms_3pax)) + (parseInt(item.num_rooms_4pax)) + (parseInt(item.num_rooms_5pax)));
            }
        },

        closeAvailability() {
            this.addAvailability = false; 
            this.isEditAvailability = false;
            this.pax = 0;
            this.rooms = 0; 
            this.error = {start_date: false, end_date: false, availability_msg: false};
            this.newAvailability = {
                num_rooms_1pax: 0,
                num_rooms_2pax: 0,
                num_rooms_3pax: 0,
                num_rooms_4pax: 0,
                num_rooms_5pax: 0
            }; 
        },

        saveAvailability() {
            var self = this;
            var validate = true;

            this.newAvailability.parsedEntryDate == null || this.newAvailability.parsedEntryDate == '' ? (this.error.start_date = true) && (validate = false) : this.error.start_date = false;

            this.newAvailability.parsedDepartureDate == null || this.newAvailability.parsedDepartureDate == '' ? (this.error.end_date = true) && (validate = false) : this.error.end_date = false;

            if( !this.error.start_date && !this.error.end_date && moment(this.newAvailability.parsedDepartureDate, "DD/MM/YYYY").isBefore(moment(this.newAvailability.parsedEntryDate, "DD/MM/YYYY")) ){
                this.error.start_date = true
                this.error.end_date = true
                validate = false
                this.error.availability_msg = "hotels.errors.availabity_dates_invalid"
            }
            else {
                var self = this
                for( var k in self.availability ) {
                    var day = self.availability[k]
                    if( day.id != self.newAvailability.id ){
                        // if( moment(this.newAvailability.parsedEntryDate, "DD/MM/YYYY").isSame( moment(day.start_date, "YYYY-MM-DD")) || moment(this.newAvailability.parsedDepartureDate, "DD/MM/YYYY").isSame( moment(day.start_date, "YYYY-MM-DD")) ){
                        if( (moment(day.start_date, "YYYY-MM-DD").isSameOrBefore(moment(this.newAvailability.parsedEntryDate, "DD/MM/YYYY")) && moment(day.end_date, "YYYY-MM-DD").isAfter(moment(this.newAvailability.parsedEntryDate, "DD/MM/YYYY"))) ||
                        ( (moment(day.start_date, "YYYY-MM-DD").isBefore(moment(this.newAvailability.parsedDepartureDate, "DD/MM/YYYY")) && moment(day.end_date, "YYYY-MM-DD").isSameOrAfter(moment(this.newAvailability.parsedDepartureDate, "DD/MM/YYYY")) ))){
                            this.error.start_date = true
                            this.error.end_date = true
                            validate = false
                            this.error.availability_msg = "hotels.errors.availabity_date_exists"
                        }
                    }
                }
            }
            
            self.error.visible = false
            
            if ( validate ) {
                var event_id = ( this.$store.getters.isEventSelected ) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false;
                this.error.availability_msg = false
                this.newAvailability.visible = this.newAvailability.visible ? 1 : 0
                this.$store.dispatch( 'hotels/saveAvailability', { hotel_id: this.hotel.id, event_id: event_id, data: this.newAvailability, isEdit: this.isEditAvailability } ).then( function(){
                    self.closeAvailability();
                    self.$store.dispatch( 'hotels/loadAvailability', { hotel_id: self.hotel.id, event_id: event_id } ).then( function(){
                    });
                });
            }
        },

        deleteAvailability(item) {
            var self = this;
            var event_id = ( this.$store.getters.isEventSelected ) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false;

            this.$popup.confirm({
            message: i18n.t( "hotels.delete_availability" ),
            btnSuccess: i18n.t( 'accept' ),
            btnError: i18n.t( 'cancel' )
            }, function(){
                self.$store.dispatch( 'hotels/removeAvailability', { hotel_id: self.hotel.id, event_id: event_id, data: item} ).then( function(isSuccess){
                if ( !isSuccess ) {
                    self.$popup.alert({
                      message: i18n.t( "hotels.error_delete_availability" ),
                      btnSuccess: i18n.t( "accept" )
                    });
                }

                });
            },
            function(){
                self.$comboSelector.close();
            })
        },

        // ROOMING POPUP METHODS
        closeRooming() {
            this.addRooming = false; 
            this.isEditRooming = false;
            this.pax = 0;
            this.rooms = 0; 
            this.error = {start_date: false, end_date: false};
            this.selectedTeamId = false;
            this.team_rooming = [];
            this.categorySelected = false
        },

        loadRoomingTeam() {
            this.availability_rooming = {...this.availability};
            var self = this;

            this.$store.dispatch( 'teams/loadRooming', { team_id: this.selectedTeamId, event_id: this.currentEvent.id } ).then( function(){
                var team_rooming = Object.values(self.$store.getters[ 'teams/getRooming' ]).filter(obj => {
                    return obj.hotel_id == null;
                });
                self.team_rooming = team_rooming;
            });
        },

        loadRoomingCategory() {
            this.availability_rooming = {...this.availability};
            var self = this;
            
            this.$store.dispatch( 'teams/loadMultipleCategoryRooming', { category_id: this.categorySelected, event_id: this.currentEvent.id } ).then( function(){
                var team_rooming = Object.values(self.$store.getters[ 'teams/getRooming' ]).filter(obj => {
                    return obj.hotel_id == null;
                });
                self.team_rooming = [...team_rooming];
            });
        },

        calculateRoomingInAvaiability(item) {
            var parsedAvailability = [];
            var team_rooming = JSON.parse(JSON.stringify({...this.team_rooming}));

            // CLEAN USED ROOMS OF DISPONIBILITY
            for (var index in this.availability) {
                parsedAvailability[this.availability[index].start_date] = JSON.parse(JSON.stringify({...this.availability[index]}));
            }

            // ITEM SELECTED
            if ( item.item.selected ) {
                team_rooming[item.index].selected = false;
            }
            // ITEM NOT SELECTED
            else {
                var bError = false;
                var date = moment(item.item.start_date);

                while ( date.valueOf() < moment(item.item.end_date).valueOf() && !bError ) {
                    if ( typeof parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")] == 'undefined' ) {
                        bError = true;
                        break;
                    }
                    date.add(1, 'days');
                }

                // CHECK OR UNCHECK IF IT IS POSIBLE
                if (bError) {
                    team_rooming[item.index].selected = false;
                } else {
                    team_rooming[item.index].selected = true;
                }
            }

            // CALCULATE USED ROOMS
            var roomingsSelected = Object.values(team_rooming).filter(obj => {
                return obj.selected == true;
            });

            if ( roomingsSelected.length > 0 ) {
                for (var index in roomingsSelected) {
                    var item = roomingsSelected[index];             
                    var date = moment(item.start_date);

                    while ( date.valueOf() < moment(item.end_date).valueOf() ) {
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_1pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_1pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_1pax_used) : 0 ) + parseInt(item.num_rooms_1pax);
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_2pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_2pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_2pax_used) : 0 ) + parseInt(item.num_rooms_2pax);
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_3pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_3pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_3pax_used) : 0 ) + parseInt(item.num_rooms_3pax);
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_4pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_4pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_4pax_used) : 0 ) + parseInt(item.num_rooms_4pax);
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_5pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_5pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_5pax_used) : 0 ) + parseInt(item.num_rooms_5pax);

                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].rooms_used = parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_1pax_used + parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_2pax_used + parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_3pax_used + parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_4pax_used + parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_5pax_used;

                        date.add(1, 'days');
                    }
                }
            }

            this.availability_rooming = {...parsedAvailability};
            this.team_rooming = Object.values(team_rooming);
        },

        saveRooming() {
            var self = this;

            var roomingsSelected = Object.values(this.team_rooming).filter(obj => {
                return obj.selected == true;
            });
            if ( this.selectedTeamId || roomingsSelected.length > 0 ) {

                var iRoomings = '';
                for (var index in roomingsSelected) {
                    iRoomings != '' ? iRoomings += ',' : true;
                    iRoomings += roomingsSelected[index].id;
                }

                this.$store.dispatch( 'hotels/assignRoomingToHotel', { hotel_id: this.hotel.id, event_id: this.currentEvent.id, rooming_id: iRoomings } ).then( function(){
                    self.team_rooming = Object.values(self.$store.getters[ 'teams/getRooming' ]);
                    self.closeRooming();
                    self.loadData();
                });
            } else {

            }
        },

        loadChangeHotelRooming( id ) {
            this.changeHotelRooming = true;
            this.currentRooming = {...this.roomings_assigned[ id ]};
            //TODO THIS ONLY WORKS FOR TEAMS
            this.currentRooming.team = this.teams[ this.currentRooming.entity_id ];
            this.changehotel_rooming_hotel_id = this.$route.params.id;
        },

        changeHotelCalculateRoomingInAvaiability() {
            if( this.changehotel_rooming_hotel_id != this.$route.params.id ){
                var parsedAvailability = [];
                var team_rooming = JSON.parse(JSON.stringify({...this.team_rooming}));

                // CLEAN USED ROOMS OF DISPONIBILITY
                for (var index in this.changehotel_availability_rooming) {
                    parsedAvailability[this.changehotel_availability_rooming[index].start_date] = this.changehotel_availability_rooming[index];
                }

                var item = {...this.currentRooming};
                var date = moment(item.start_date);

                var self = this
                while ( date.valueOf() < moment(item.end_date).valueOf() && !this.changehotel_rooming_error ) {
                    if ( typeof parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")] == 'undefined' ) {
                        self.changehotel_rooming_error = true;
                        break;
                    }
                    date.add(1, 'days');
                }

                if( !this.changehotel_rooming_error ){
                    date = moment(item.start_date);

                    while ( date.valueOf() < moment(item.end_date).valueOf() ) {
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_1pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_1pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_1pax_used) : 0 ) + parseInt(item.num_rooms_1pax);
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_2pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_2pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_2pax_used) : 0 ) + parseInt(item.num_rooms_2pax);
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_3pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_3pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_3pax_used) : 0 ) + parseInt(item.num_rooms_3pax);
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_4pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_4pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_4pax_used) : 0 ) + parseInt(item.num_rooms_4pax);
                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_5pax_used = ( parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_5pax_used != null ? parseInt(parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_5pax_used) : 0 ) + parseInt(item.num_rooms_5pax);

                        parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].rooms_used = parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_1pax_used + parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_2pax_used + parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_3pax_used + parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_4pax_used + parsedAvailability[date.format("YYYY-MM-DD HH:mm:ss")].num_rooms_5pax_used;

                        date.add(1, 'days');
                    }

                    this.changehotel_availability_rooming = parsedAvailability;
                    this.team_rooming = Object.values(team_rooming);
                }
                else{
                    this.$popup.alert({
                        message: i18n.t("hotels.hotel_availability_no_complete"),
                        btnSuccess: i18n.t("accept")
                    });
                }
            }
        },

         // CHANGE HOTEL ROOMING POPUP METHODS
        closeChangeHotelRooming() {
            this.changeHotelRooming = false; 
            this.isEditRooming = false;
            this.currentRooming = false;
        },

        saveChangeHotelRooming() {
            var self = this;
            if( !this.changehotel_rooming_error ){
                this.$store.dispatch( 'hotels/changeHotelRooming', { hotel_id: this.changehotel_rooming_hotel_id, event_id: this.currentEvent.id, rooming_id: this.currentRooming.id } ).then( function(){
                    self.closeChangeHotelRooming();
                    self.loadData();
                });
            }
            else{
                this.$popup.alert({
                    message: i18n.t("hotels.hotel_availability_no_complete"),
                    btnSuccess: i18n.t("accept")
                });
            }
        },

        roomingStatus( v ){
            var status = this.$store.getters['hotels/getRoomingStatus'](v)
            return i18n.t(status.name)
        },

        getTeam( team_id ){
            return this.$store.getters['teams/get_by_id']( team_id );
        },

        roomingStatus( v ){
            var status = this.$store.getters['hotels/getRoomingStatus'](v)
            return i18n.t(status.name)
        },

        exportRooming() {
            var self = this
            var event = this.$store.getters.isEventSelected
                ? this.$store.getters["events/getCurrentEvent"]()
                : false;
            event = event ? event.id : false;

            if( !event ){
                self.$popup.alert({
                    message: "Error desconocido",
                    btnSuccess: i18n.t("accept")
                });
            }
            else {
                var path = "hotel/event/" + event + "/export/rooming";

                this.$overlay.loading()

                return api
                    .post(path, { data: this.hotel.id })
                    .then(function(response) {
                        const link = document.createElement("a");
                        link.href = response.data.url;
                        var aName = response.data.url.split('/')
                        link.setAttribute("download", aName[ aName.length - 1 ]);
                        document.body.appendChild(link);
                        link.click();
                        self.$overlay.hide()
                    });
            }
        }
    },
    watch: {
        changehotel_rooming_hotel_id: {
            handler( v ){
                var self = this
                this.changehotel_rooming_error = false;
                if( v != null ){
                    this.$store.dispatch( 'hotels/loadAvailability', { hotel_id: v, event_id: this.$store.getters[ 'events/getCurrentEvent']().id, save: false } ).then( function( response ){
                        self.changehotel_availability_rooming = response;
                        self.changeHotelCalculateRoomingInAvaiability()
                    });
                }
                else{
                    self.changehotel_availability_rooming = [];
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .inlineblock {
        display: inline-block;
    }

    #hotel {
        width: 100%;
        display: inline-block;

        .container {
            width: 80%;
            width: calc(100% - 350px);
            padding: 0px;

            &.main {
            overflow-y: auto;
            height: calc(100vh - 110px);
            }

            .section-container {
                padding: 20px;
                
                &#basic {
                    background-color: #fff;
                    @include  box-shadow( $h: 0px , $v: 3px , $b: 8px , $s: 0px , $c: #00000011 );
                }
                &#notes {
                    background-color: $complem-color-light; 
                }
                &#teams {
                    background-color: #fff;
                    @include  box-shadow( $h: 0px , $v: -3px , $b: 8px , $s: 0px , $c: #00000011 );
                }
            }
        }

        .contact {
            width: 20%;
            width: 350px;
            padding: 20px;
        }
    
        .logo {
            width: 150px;
            height: 150px;
            border-radius: 50%;

            img {
                object-fit: contain;
                object-position: center;
                height: 100%;
                width: auto;
                margin: 0 auto;
                display: block;
                margin-top: 50px;
                opacity: 0.5;
            }
        }
        .info {

            .icon, .v-image {
                height: 20px !important;
                width: 20px !important;
            }

            .container {
                margin: 0;
                padding: 0 20px;
                padding-left: 40px;
                width: 100%;

                .section {
                    margin-bottom: 75px;

                    .name {
                        font-weight: lighter;
                        font-size: 24px;
                        @include font-size(14px);
                        border-bottom: 1px solid #ddd;
                        margin: 10px 0 20px 0;
                        color: $main-color;
                        text-transform: uppercase;
                        margin-bottom: 20px;
                        border-bottom: 2px solid $complem-color-dark;
                        color: $complem-color-dark;
                        position: relative;
                        width: fit-content;
                        cursor: pointer;
                        padding-bottom: 5px;
                        font-family: Roboto-Bold;

                        .add {
                            content: "";
                            position: absolute;
                            /* width: 40px; */
                            /* height: 25px; */
                            /* border: 1px solid #000; */
                            /* border-radius: 50%; */
                            background: url(/img/add_b.svg);
                            background-repeat: no-repeat;
                            background-size: 12px;
                            background-position: left center;
                            padding-left: 20px;
                            top: -5px;
                            right: 0;
                            font-size: 14px;
                        }
                    }

                    .name {
                        font-weight: lighter;
                        font-size: 24px;
                        @include font-size(14px);
                        border-bottom: 1px solid #ddd;
                        margin: 10px 0 20px 0;
                        color: $main-color;
                        text-transform: uppercase;
                        margin-bottom: 20px;
                        border-bottom: 2px solid $complem-color-dark;
                        color: $complem-color-dark;
                    }

                    .label {
                        font-family: $text-light;
                        @include font-size(14px);
                        width: 40%;
                        float: left;
                        line-height: 20px;
                    }

                    .value {
                        font-family: $text;
                        font-weight: lighter;
                        @include font-size(14px);
                        width: 60%;
                        float: left;
                        margin-bottom: 10px;
                    }

                    .edit {
                        background-image: url(/img/edit-b.svg);
                        background-size: 15px;
                        background-repeat: no-repeat;
                        background-position: left center;
                        position: absolute;
                        right: 0;
                        top: -5px;
                        padding-left: 20px;
                        text-transform: none;
                        font-weight: bold;
                    }
                }
            }
        }

        .overbooking {
            font-weight: bold;
            color: #c51818;
        }

        .total {
            font-size: 11px;
        }
    }

    .popup {
        .counter {
            background-color: #eee; 
            padding: 3px 10px;
            margin: 0px 10px;
            color: #888;
            font-size: 18px;
            cursor: default;
        }

        .input-error {
            border: 1px solid red !important;
        }

        .label {
            &.error {
                color: $alert-color;
                font-weight: bold;
            }
        }

        .item {
            width: 90%;
            margin-bottom: 20px;
        }

        .rooms {
            margin: 30px 0px;

            .room {
                width: calc(100% / 5);

                .room-quantity {
                    width: 40px;
                    border: 1px solid black;
                    text-align: center;
                    padding: 5px;
                    margin: 0px 5px;
                }    
            }
        }

        .v-input__slot {
            background-color: red !important;
            border-bottom: none !important;
        }

        #checkbox {
            .v-input__slot .v-input--selection-controls__input & {
                background-color: red !important;
                border-bottom: none !important;
            }
        }

        &.changehotel {
            .item {
                margin-bottom: 0;
            }
        }
    }

    .rooming {
        .total {
            font-size: 11px;
        }
        .overbooking {
            font-weight: bold;
            color: #c51818;
        }
    }

</style>

<style type="scss">
    
    div.rooming.popup > div.v-card__text > div > div > div > div > div > div.flex.xs12.md12 > div.elevation-1 > div > table > tbody > tr > td > div > div > div {
        border: none !important;
    }

    .centertext {
        text-align: center !important;
    }

</style>
